import React, { useEffect, useState } from "react";
import { useDpConfig } from "../../contexts/dpConfig";
import {
  Checkbox,
  PrivacyPolicyModal,
  TermsAndConditionsModal,
} from "../../components";
import { LoanProductType } from "../../hooks/api/types";
import { useLoanProductConfigFlags } from "../../hooks/useLoanProductConfigFlags";

type Props = {
  onTermsChange: (checked: boolean) => void;
  loanType: LoanProductType;
};

const TermsAndConditionsSection: React.FC<Props> = ({
  onTermsChange,
  loanType,
}) => {
  const [termsAndConditionsCheckbox, setTermsAndConditionsCheckbox] =
    useState<boolean>(true);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);

  const { state } = useDpConfig();

  const { isPartnerTermsAccepted } = useLoanProductConfigFlags(loanType);

  const handleCheckboxChange = () => {
    const newValue = !termsAndConditionsCheckbox;
    setTermsAndConditionsCheckbox(newValue);
    onTermsChange(newValue);
  };

  useEffect(() => {
    if (isPartnerTermsAccepted !== undefined) {
      setTermsAndConditionsCheckbox(isPartnerTermsAccepted);
      onTermsChange(isPartnerTermsAccepted);
    }
  }, [state]);

  return (
    <div className={"cx-w-full"}>
      <div className={"cx-text-neutral-darker cx-text-sm cx-w-full"}>
        By clicking Continue, I acknowledge and agree to be bound by Credible
        X's{" "}
        <span
          className={"cx-text-primary hover:cx-cursor-pointer"}
          onClick={() => {
            setTermsModalOpen(true);
          }}
        >
          Terms & Conditions
        </span>{" "}
        and{" "}
        <span
          className={"cx-text-primary hover:cx-cursor-pointer"}
          onClick={() => {
            setPrivacyModalOpen(true);
          }}
        >
          Privacy Policy
        </span>
      </div>
      {state.dpTermsUrl && (
        <div className="cx-text-neutral-darker cx-mt-4 cx-flex cx-items-start cx-gap-3 cx-text-sm cx-w-full">
          <Checkbox
            label=""
            variant="slim"
            labelClassnames="cx-text-sm"
            checked={termsAndConditionsCheckbox}
            onChange={handleCheckboxChange}
          />
          <div className="cx-flex-1 cx-leading-snug">
            <span>I have read and accept the {state.name} </span>
            <span
              className="cx-text-brand-primary-regular hover:cx-cursor-pointer"
              onClick={() => {
                window.open(`${state.dpTermsUrl}`, "_blank");
              }}
            >
              Terms & Conditions
            </span>
          </div>
        </div>
      )}
      <TermsAndConditionsModal
        isOpen={termsModalOpen}
        onClose={() => setTermsModalOpen(false)}
      />
      <PrivacyPolicyModal
        isOpen={privacyModalOpen}
        onClose={() => setPrivacyModalOpen(false)}
      />
    </div>
  );
};

export default TermsAndConditionsSection;
